export const GET_SETTING = "GET_SETTING";
export const UPDATE_SETTING = "UPDATE_SETTING";
export const UPDATE_GAME_STATUS = "UPDATE_GAME_STATUS";